import React from 'react';

const Footer: React.FC = () => {
  return (
    <footer className="bg-black text-white py-20 px-6 lg:px-20 border-t border-white/10">
      <div className="max-w-[1440px] mx-auto flex flex-col gap-16">
        <div className="grid md:grid-cols-3 items-center gap-12">
          <div className="flex items-center gap-4">
            <div className="size-10 bg-primary flex items-center justify-center">
              <span className="material-symbols-outlined text-white">rocket_launch</span>
            </div>
            <h2 className="text-xl font-black uppercase tracking-widest italic">T.H.E Apps Studio</h2>
          </div>
          
          <div className="flex justify-center gap-10 text-xs font-black tracking-widest uppercase text-white/40">
            <a className="hover:text-primary transition-colors cursor-pointer">Instagram</a>
            <a className="hover:text-primary transition-colors cursor-pointer">Dribbble</a>
            <a className="hover:text-primary transition-colors cursor-pointer">LinkedIn</a>
            <a className="hover:text-primary transition-colors cursor-pointer">Twitter</a>
          </div>
          
          <div className="flex flex-col md:items-end gap-1">
            <span className="text-[10px] font-black uppercase tracking-widest text-white/20">Studio Support</span>
            <a href="mailto:rob@theapps.io" className="text-sm font-black uppercase tracking-widest text-white hover:text-primary transition-colors italic">
              rob@theapps.io
            </a>
          </div>
        </div>

        <p className="text-center text-[10px] font-bold text-white/10 tracking-[0.4em] uppercase pt-12 border-t border-white/5">
          © {new Date().getFullYear()} T.H.E Apps Studio. All rights reserved.
        </p>
      </div>
    </footer>
  );
};

export default Footer;